import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Country from "@/pcm/store/models/Country";

export default class ClientPaymentInformation extends Model {
    static entity = 'client_payment_information';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            client_id: this.uid(),
            address: this.string(null).nullable(),
            zip_code: this.string(null).nullable(),
            city: this.string(null).nullable(),
            country_id: this.attr(null).nullable(),
            name: this.string(null).nullable(),
            email: this.string(null).nullable(),
            paypalme_link: this.string(null).nullable(),
            wise_type: this.string(null).nullable(),
            wise_account: this.string(null).nullable(),
            swift: this.string(null).nullable(),
            iban: this.string(null).nullable(),
            bank_name: this.string(null).nullable(),
            bank_address: this.string(null).nullable(),
            account_number: this.string(null).nullable(),
            account_address: this.string(null).nullable(),
            industry_code: this.string(null).nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),

            country: this.belongsTo(Country, 'country_id'),
        }
    }

    declare id: number;
    declare client_id: number;
    declare address: string | null;
    declare zip_code: string | null;
    declare city: string | null;
    declare country_id: number | null;
    declare name: string | null;
    declare email: string | null;
    declare paypalme_link: string | null;
    declare wise_type: string | null;
    declare wise_account: string | null;
    declare swift: string | null;
    declare iban: string | null;
    declare bank_name: string | null;
    declare bank_address: string | null;
    declare account_number: string | null;
    declare account_address: string | null;
    declare industry_code: string | null;
    declare country: Country | null;
}
